import React from 'react';
import { Box } from '@mui/material';
import { statusColors, palette } from './designTokens';

const StatusPill = ({ status, label, size = 'md' }) => {
  const c = statusColors[status] || { fg: palette.muted, bg: palette.surfaceAlt };
  const padY = size === 'sm' ? 0.1 : 0.25;
  const padX = size === 'sm' ? 0.875 : 1.125;
  const fontSize = size === 'sm' ? 10 : 11;
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: padX, py: padY,
        bgcolor: c.bg,
        color: c.fg,
        fontSize,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        borderRadius: '999px',
        whiteSpace: 'nowrap',
      }}
    >
      {label || status?.replaceAll('_', ' ')}
    </Box>
  );
};

export default StatusPill;
